/**
 * logoDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const logoDesignsPack: ToilePack = {
    slug: 'logo-designs',
    category: 'logo',
    name: 'Logo designs',
    tagline: tagline('logos', 'businesses', 'styles'),
    chips: chips('businesses', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'bakery', label: 'Mill & Crumb', subject: 'a sourdough bakery, a wheat sheaf and a loaf'},
        {key: 'dive', label: 'Blue Fathom', subject: 'a scuba diving school, a diver silhouette and a wave'},
        {key: 'bike', label: 'Spoke', subject: 'a bicycle repair shop, a wheel with spokes and a wrench'},
    ],
    styles: [
        {key: 'monogram', label: 'Monogram', style: 'minimal geometric mark, name below', palette: 'black on white', framing: 'centered, flat vector sheet'},
        {key: 'badge', label: 'Badge', style: 'vintage circular badge, ribbon banner', palette: 'two-ink letterpress on cream', framing: 'centered, flat vector sheet'},
        {key: 'mascot', label: 'Mascot', style: 'flat cartoon mascot character', palette: 'bright three-color palette', framing: 'centered, flat vector sheet'},
    ],
    directions: ['a coffee roaster instead', 'in one deep green', 'simpler, fewer elements'],
}
